import React from 'react';
import PropTypes from 'prop-types';

import * as Cookie from 'js-cookie';
import AnimateHeight from 'react-animate-height';
import {Link} from 'react-router';

import styles from './CookieConsent.m.sass';
import Button from '../button/Button';
import RoundButton from "../roundButton/RoundButton";
import CloseSmallIcon from '-!svg-react-loader?name=CloseSmallIcon!../header/assets/close-small.svg';

export default class CookieConsent extends React.PureComponent {
  static COOKIE_CONSENT_KEY = 'cookieConsent';

  constructor(props) {
    super(props);
    this.state = {open: false, show: false};
  }

  onAgree = () => {
    Cookie.set(CookieConsent.COOKIE_CONSENT_KEY, 'y');
    this.setState({open: false});
  };

  componentDidMount() {
    const haveConsent = Cookie.get(CookieConsent.COOKIE_CONSENT_KEY);
    if (!haveConsent) {
      this.setState({show: true});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {open, show} = this.state;

    if (prevState.show === false && show === true && open === false) {
      setTimeout(() => this.setState({open: true}), 300);
    }
  }

  render() {
    const {open, show} = this.state;

    if (!show) {
      return false;
    }

    return (
      <AnimateHeight height={open ? 'auto' : 0} duration={300}>
        <div className={styles.cookieConsent}>
          <div className={styles.cookieConsent_close}>
            <RoundButton
              onClick={this.onAgree}
              accent
              extraSmall
            >
              <CloseSmallIcon/>
            </RoundButton>
          </div>

          <div className={styles.cookieConsent_container}>
            <div className={styles.cookieConsent_desc}>
              <div className={styles.cookieConsent_text}>
                By continuing to use this site you agree to the use of cookies in accordance with our
                {' '}
                <Link to="/page/privacy-policy">privacy policy</Link>
              </div>

              <div className={styles.cookieConsent_actions}>
                <Button extraSmall onClick={this.onAgree}>I Accept</Button>
              </div>
            </div>
          </div>
        </div>
      </AnimateHeight>
    );
  }
}



// WEBPACK FOOTER //
// ./components/cookieConsent/CookieConsent.js